<!-- eslint-disable prettier/prettier -->
<template>
	<v-container class="fill-height" style="background: rgba(255, 255, 255, 0.9)">
		<v-row justify="space-around" style="background: white">
			<v-col cols="4" class="text-center">
				<h1>Ply can't run due to browser settings</h1>
				<span
					><a
						href="https://docs.ply.io/article/wu1i3llntf-i-click-a-button-and-a-loader-appears-but-the-interface-doesn-t-display"
						target="_blank"
						>Click here to learn how fix it</a
					></span
				>
				<br /><br />
				<span style="font-size: 11px"><a href="/">Try again</a> or <a href="" @click.prevent="cancel">close</a></span>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import IframeService from '@/utils/iframe-service';

/* eslint-disable no-undef */
export default {
	name: 'PrivacySettingsPage',
	props: {},
	computed: {},
	methods: {
		cancel() {
			IframeService.sendMessageToParent({ action: 'cancelClicked' });
		},
	},
	async mounted() {},
};
</script>

<style scoped></style>
